const AdjustmentCodes = {
    '1': 'Deductible Amount',
    '2': 'Coinsurance Amount',
    '3': 'Co-payment Amount',
    '4': 'The procedure code is inconsistent with the modifier used or a required modifier is missing',
    '5': 'The procedure code/type of bill is inconsistent with the place of service.',
    '6': "The procedure/revenue code is inconsistent with the patient's age. ",
    '7': "The procedure/revenue code is inconsistent with the patient's gender. ",
    '8': 'The procedure code is inconsistent with the provider type/specialty (taxonomy).',
    '9': "The diagnosis is inconsistent with the patient's age.",
    '10': "The diagnosis is inconsistent with the patient's gender.",
    '11': 'The diagnosis is inconsistent with the procedure.',
    '12': 'The diagnosis is inconsistent with the provider type.',
    '13': 'The date of death precedes the date of service.',
    '14': 'The date of birth follows the date of service.',
    '16': 'Claim/service lacks information or has submission/billing error(s).',
    '18': 'Exact duplicate claim/service.',
    '19': "This is a work-related injury/illness and thus the liability of the Worker's Compensation Carrier.",
    '20': 'This injury/illness is covered by the liability carrier.',
    '21': 'This injury/illness is the liability of the no-fault carrier.',
    '22': 'This care may be covered by another payer per coordination of benefits.',
    '23': 'The impact of prior payer(s) adjudication including payments and/or adjustments.',
    '24': 'Charges are covered under a capitation agreement/managed care plan.',
    '26': 'Expenses incurred prior to coverage.',
    '27': 'Expenses incurred after coverage terminated.',
    '29': 'The time limit for filing has expired.',
    '31': 'Patient cannot be identified as our insured.',
    '32': 'Our records indicate the patient is not an eligible dependent.',
    '33': 'Insured has no dependent coverage.',
    '34': 'Insured has no coverage for newborns.',
    '35': 'Lifetime benefit maximum has been reached.',
    '39': 'Services denied at the time authorization/pre-certification was requested.',
    '38': 'Services not provided or authorized by designated (network / primary care) providers.',
    '40': 'Charges do not meet qualifications for emergent/urgent care. ',
    '44': 'Prompt-pay discount.',
    '45': 'Charge exceeds fee schedule/maximum allowable or contracted/legislated fee arrangement.',
    '49':
        'This is a non-covered service because it is a routine/preventive exam or a diagnostic/screening procedure done in conjunction with a routine/preventive exam. ',
    '50': "These are non-covered services because this is not deemed a 'medical necessity' by the payer.",
    '51': 'These are non-covered services because this is a pre-existing condition.',
    '53': 'Services by an immediate relative or a member of the same household are not covered.',
    '54': 'Multiple physicians/assistants are not covered in this case.',
    '55': 'Procedure/treatment/drug is deemed experimental/investigational by the payer.',
    '56': "Procedure/treatment has not been deemed 'proven to be effective' by the payer. ",
    '58': 'Treatment was deemed by the payer to have been rendered in an inappropriate or invalid place of service.',
    '59': 'Processed based on multiple or concurrent procedure rules.',
    '60':
        'Charges for outpatient services are not covered when performed within a period of time prior to or after inpatient services.',
    '61': 'Adjusted for failure to obtain second surgical opinion.',
    '66': 'Blood Deductible.',
    '69': 'Day outlier amount.',
    '70': 'Cost outlier - Adjustment to compensate for additional costs.',
    '74': 'Indirect Medical Education Adjustment.',
    '75': 'Direct Medical Education Adjustment.',
    '76': 'Disproportionate Share Adjustment.',
    '78': 'Non-Covered days/Room charge adjustment.',
    '85': 'Patient Interest Adjustment.',
    '89': 'Professional fees removed from charges.',
    '90': 'Ingredient cost adjustment. ',
    '91': 'Dispensing fee adjustment.',
    '94': 'Processed in Excess of charges.',
    '95': 'Plan procedures not followed.',
    '96': 'Non-covered charge(s). ',
    '97':
        'The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated.',
    '100': 'Payment made to patient/insured/responsible party.',
    '101': 'Predetermination: anticipated payment upon completion of services or claim adjudication.',
    '102': 'Major Medical Adjustment.',
    '103': 'Provider promotional discount',
    '104': 'Managed care withholding.',
    '105': 'Tax withholding.',
    '106': 'Patient payment option/election not in effect.',
    '107': 'The related or qualifying claim/service was not identified on this claim. ',
    '108': 'Rent/purchase guidelines were not met.',
    '109': 'Claim/service not covered by this payer/contractor.',
    '110': 'Billing date predates service date.',
    '111': 'Not covered unless the provider accepts assignment.',
    '112': 'Service not furnished directly to the patient and/or not documented.',
    '114': 'Procedure/product not approved by the Food and Drug Administration.',
    '115': 'Procedure postponed, canceled, or delayed.',
    '116': 'The advance indemnification notice signed by the patient did not comply with requirements.',
    '117': 'Transportation is only covered to the closest facility that can provide the necessary care.',
    '118': 'ESRD network support adjustment.',
    '119': 'Benefit maximum for this time period or occurrence has been reached.',
    '121': 'Indemnification adjustment - compensation for outstanding member responsibility.',
    '122': 'Psychiatric reduction.',
    '128': "Newborn's services are covered in the mother's Allowance.",
    '129': 'Prior processing information appears incorrect. ',
    '130': 'Claim submission fee.',
    '131': 'Claim specific negotiated discount.',
    '132': 'Prearranged demonstration project adjustment.',
    '133': 'The disposition of this service line is pending further review.',
    '134': 'Technical fees removed from charges.',
    '135': 'Interim bills cannot be processed.',
    '136': "Failure to follow prior payer's coverage rules.",
    '137': 'Regulatory Surcharges, Assessments, Allowances or Health Related Taxes.',
    '139': 'Contracted funding agreement - Subscriber is employed by the provider of services.',
    '140': 'Patient/Insured health identification number and name do not match.',
    '142': 'Monthly Medicaid patient liability amount.',
    '143': 'Portion of payment deferred.',
    '144': 'Incentive adjustment, e.g. preferred product/service.',
    '146': 'Diagnosis was invalid for the date(s) of service reported.',
    '147': 'Provider contracted/negotiated rate expired or not on file.',
    '148': 'Information from another provider was not provided or was insufficient/incomplete.',
    '149': 'Lifetime benefit maximum has been reached for this service/benefit category.',
    '150': 'Payer deems the information submitted does not support this level of service.',
    '151':
        'Payment adjusted because the payer deems the information submitted does not support this many/frequency of services.',
    '152': 'Payer deems the information submitted does not support this length of service.',
    '153': 'Payer deems the information submitted does not support this dosage.',
    '154': "Payer deems the information submitted does not support this day's supply.",
    '155': 'Patient refused the service/procedure.',
    '157': 'Service/procedure was provided as a result of an act of war.',
    '158': 'Service/procedure was provided outside of the United States.',
    '159': 'Service/procedure was provided as a result of terrorism.',
    '160': 'Injury/illness was the result of an activity that is a benefit exclusion.',
    '161': 'Provider performance bonus.',
    '163': 'Attachment/other documentation referenced on the claim was not received.',
    '164': 'Attachment/other documentation referenced on the claim was not received in a timely fashion.',
    '166':
        'These services were submitted after this payers responsibility for processing claims under this plan ended.',
    '167': 'This (these) diagnosis(es) is (are) not covered.',
    '169': 'Alternate benefit has been provided.',
    '170': 'Payment is denied when performed/billed by this type of provider.',
    '171': 'Payment is denied when performed/billed by this type of provider in this type of facility. ',
    '172': 'Payment is adjusted when performed/billed by a provider of this specialty.',
    '173': 'Service/equipment was not prescribed by a physician.',
    '174': 'Service was not prescribed prior to delivery.',
    '175': 'Prescription is incomplete.',
    '176': 'Prescription is not current.',
    '177': 'Patient has not met the required eligibility requirements.',
    '178': 'Patient has not met the required spend down requirements.',
    '179': 'Patient has not met the required waiting requirements.',
    '180': 'Patient has not met the required residency requirements.',
    '1811': 'Procedure code was invalid on the date of service.',
    '182': 'Procedure modifier was invalid on the date of service.',
    '183': 'The referring provider is not eligible to refer the service billed.',
    '184': 'The prescribing/ordering provider is not eligible to prescribe/order the service billed.',
    '185': 'The rendering provider is not eligible to perform the service billed.',
    '186': 'Level of care change adjustment.',
    '187':
        'Consumer Spending Account payments (includes but is not limited to Flexible Spending Account, Health Savings Account, Health Reimbursement Account, etc.)',
    '188': 'This product/procedure is only covered when used according to FDA recommendations.',
    '189':
        "Not otherwise classified' or 'unlisted' procedure code (CPT/HCPCS) was billed when there is a specific procedure code for this procedure/service",
    '190': 'Payment is included in the allowance for a Skilled Nursing Facility (SNF) qualified stay.',
    '192': 'Non standard adjustment code from paper remittance.',
    '193':
        'Original payment decision is being maintained. Upon review, it was determined that this claim was processed properly.',
    '194': 'Anesthesia performed by the operating physician, the assistant surgeon or the attending physician.',
    '195': 'Refund issued to an erroneous priority payer for this claim/service.',
    '197': 'Precertification/authorization/notification/pre-treatment absent.',
    '198': 'Precertification/notification/authorization/pre-treatment exceeded.',
    '199': 'Revenue code and Procedure code do not match.',
    '200': 'Expenses incurred during lapse in coverage.',
    '201':
        "Patient is responsible for amount of this claim/service through 'set aside arrangement' or other agreement.",
    '202': 'Non-covered personal comfort or convenience services.',
    '203': 'Discontinued or reduced service.',
    '204': 'This service/equipment/drug is not covered under the patient`s current benefit plan',
    '205': 'Pharmacy discount card processing fee',
    '206': 'National Provider Identifier - missing.',
    '207': 'National Provider identifier - Invalid format',
    '208': 'National Provider Identifier - Not matched.',
    '209':
        'Per regulatory or other agreement. The provider cannot collect this amount from the patient. However, this amount may be billed to subsequent payer. Refund to patient if collected.',
    '210': 'Payment adjusted because pre-certification/authorization not received in a timely fashion',
    '211': 'National Drug Codes (NDC) not eligible for rebate, are not covered.',
    '212': 'Administrative surcharges are not covered',
    '213': 'Non-compliance with the physician self referral prohibition legislation or payer policy.',

    '215': 'Based on subrogation of a third party settlement',
    '216': 'Based on the findings of a review organization',

    '219': 'Based on extent of injury.',

    '222':
        'Exceeds the contracted maximum number of hours/days/units by this provider for this period. This is not patient specific.',
    '223':
        'Adjustment code for mandated federal, state or local law/regulation that is not already covered by another code and is mandated before a new code can be created.',
    '224':
        'Patient identification compromised by identity theft. Identity verification required for processing this and future claims.',
    '225': 'Penalty or Interest Payment by Payer (Only used for plan to plan encounter reporting within the 837)',
    '226':
        'Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete.',
    '227':
        'Information requested from the patient/insured/responsible party was not provided or was insufficient/incomplete.',
    '228':
        'Denied for failure of this provider, another provider or the subscriber to supply requested information to a previous payer for their adjudication',
    '229': 'Partial charge amount not considered by Medicare due to the initial claim Type of Bill being 12X. ',

    '231': 'Mutually exclusive procedures cannot be done in the same day/setting. ',
    '232': 'Institutional Transfer Amount.',
    '233': 'Services/charges related to the treatment of a hospital-acquired condition or preventable medical error.',
    '234': 'This procedure is not paid separately.',
    '235': 'Sales Tax',
    '236':
        'This procedure or procedure/modifier combination is not compatible with another procedure or procedure/modifier combination provided on the same day according to the National Correct Coding Initiative or workers compensation state regulations/ fee schedule requirements.',
    '237': 'Legislated/Regulatory Penalty.',
    '238': 'Claim spans eligible and ineligible periods of coverage, this is the reduction for the ineligible period.',
    '239': 'Claim spans eligible and ineligible periods of coverage. Rebill separate claims.',
    '240': "The diagnosis is inconsistent with the patient's birth weight.",
    '241': 'Low Income Subsidy (LIS) Co-payment Amount',
    '242': 'Services not provided by network/primary care providers.',
    '243': 'Services not authorized by network/primary care providers.',

    '245': 'Provider performance program withhold.',
    '246': 'This non-payable code is for required reporting only.',
    '247':
        'Deductible for Professional service rendered in an Institutional setting and billed on an Institutional claim.',
    '248':
        'Coinsurance for Professional service rendered in an Institutional setting and billed on an Institutional claim.',
    '249': 'This claim has been identified as a readmission.',
    '250':
        'The attachment/other documentation that was received was the incorrect attachment/document. The expected attachment/document is still missing.',
    '251':
        'The attachment/other documentation that was received was incomplete or deficient. The necessary information is still needed to process the claim.',
    '252': 'An attachment/other documentation is required to adjudicate this claim/service.',
    '253': 'Sequestration - reduction in federal payment',
    '254':
        "Claim received by the dental plan, but benefits not available under this plan. Submit these services to the patient's medical plan for further consideration.",

    '256': 'Service not payable per managed care contract.',
    '257':
        'The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment).',
    '258':
        'Claim/service not covered when patient is in custody/incarcerated. Applicable federal, state or local authority may cover the claim/service.',
    '259': 'Additional payment for Dental/Vision service utilization.',
    '260': 'Processed under Medicaid ACA Enhanced Fee Schedule',
    '261': "The procedure or service is inconsistent with the patient's history.",
    '262': 'Adjustment for delivery cost. Usage: To be used for pharmaceuticals only.',
    '263': 'Adjustment for shipping cost. Usage: To be used for pharmaceuticals only.',
    '264': 'Adjustment for postage cost.',
    '265': 'Adjustment for administrative cost.',
    '266': 'Adjustment for compound preparation cost. ',
    '267': 'Claim/service spans multiple months.',
    '268': 'The Claim spans two calendar years. Please resubmit one claim per calendar year.',
    '269': 'Anesthesia not covered for this service/procedure.',
    '270':
        'Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient`s dental plan for further consideration.',
    '271':
        'Prior contractual reductions related to a current periodic payment as part of a contractual payment schedule when deferred amounts have been previously reported.',
    '272': 'Coverage/program guidelines were not met.',
    '273': 'Coverage/program guidelines were exceeded.',
    '274': 'Fee/Service not payable per patient Care Coordination arrangement.',
    '275': "Prior payer's (or payers') patient responsibility (deductible, coinsurance, co-payment) not covered.",
    '276': 'Services denied by the prior payer(s) are not covered by this payer.',
    '277':
        'The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance SHOP Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment).',
    '278': 'Performance program proficiency requirements not met.',
    '279': 'Services not provided by Preferred network providers.',
    '280':
        "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's Pharmacy plan for further consideration.",
    '281': 'Deductible waived per contractual agreement.',
    '282': 'The procedure/revenue code is inconsistent with the type of bill.',
    '283': 'Attending provider is not eligible to provide direction of care.',
    '284':
        'Precertification/authorization/notification/pre-treatment number may be valid but does not apply to the billed services.',
    '285': 'Appeal procedures not followed',
    '286': 'Appeal time limits not met',
    '287': 'Referral exceeded',
    '288': 'Referral absent',
    '289': 'Services considered under the dental and medical plans, benefits not available.',
    '290':
        "Claim received by the dental plan, but benefits not available under this plan. Claim has been forwarded to the patient's medical plan for further consideration.",
    '291':
        "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's dental plan for further consideration.",
    '292':
        "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's pharmacy plan for further consideration.",
    '293': 'Payment made to employer.',
    '294': 'Payment made to attorney.',
    '295': 'Pharmacy Direct/Indirect Remuneration (DIR)',
    '296':
        'Precertification/authorization/notification/pre-treatment number may be valid but does not apply to the provider.',
    A0: 'Patient refund amount.',
    A1: 'Claim/Service denied.',

    A5: 'Medicare Claim PPS Capital Cost Outlier Amount.',
    A6: 'Prior hospitalization or 30 day transfer requirement not met.',

    A8: 'Ungroupable DRG.',
    B1: 'Non-covered visits.',

    B4: 'Late filing penalty.',

    B7: 'This provider was not certified/eligible to be paid for this procedure/service on this date of service.',
    B8: 'Alternative services were available, and should have been utilized.',
    B9: 'Patient is enrolled in a Hospice.',
    B10:
        'Allowed amount has been reduced because a component of the basic procedure/test was paid. The beneficiary is not liable for more than the charge limit for the basic procedure/test.',
    B11:
        'The claim/service has been transferred to the proper payer/processor for processing. Claim/service not covered by this payer/processor.',
    B12: "Services not documented in patient's medical records.",
    B13: 'Previously paid. Payment for this claim/service may have been provided in a previous payment.',
    B14: 'Only one visit or consultation per physician per day is covered.',
    B15:
        'This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated.',
    B16: "New Patient' qualifications were not met.",
    B20: 'Procedure/service was partially or fully furnished by another provider.',
    B22: 'This payment is adjusted based on the diagnosis.',
    B23:
        'Procedure billed is not authorized per your Clinical Laboratory Improvement Amendment (CLIA) proficiency test.',

    P1:
        'State-mandated Requirement for Property and Casualty, see Claim Payment Remarks Code for specific explanation. To be used for Property and Casualty only.',
    P2: "Not a work related injury/illness and thus not the liability of the workers' compensation carrier.",
    P3:
        "Workers' Compensation case settled. Patient is responsible for amount of this claim/service through WC 'Medicare set aside arrangement' or other agreement. To be used for Workers' Compensation only. ",
    P4:
        "Workers' Compensation claim adjudicated as non-compensable. This Payer not liable for claim or service/treatment. ",
    P5:
        'Based on payer reasonable and customary fees. No maximum allowable defined by legislated fee arrangement. To be used for Property and Casualty only.',
    P6: 'Based on entitlement to benefits.',
    P7:
        'The applicable fee schedule/fee database does not contain the billed code. Please resubmit a bill with the appropriate fee schedule/fee database code(s) that best describe the service(s) provided and supporting documentation if required. To be used for Property and Casualty only.',
    P8: 'Claim is under investigation.',
    P9:
        'No available or correlating CPT/HCPCS code to describe this service. To be used for Property and Casualty only.',
    P10:
        'Payment reduced to zero due to litigation. Additional information will be sent following the conclusion of litigation. To be used for Property and Casualty only.',
    P11:
        'The disposition of the related Property & Casualty claim (injury or illness) is pending due to litigation. To be used for Property and Casualty only.',
    P12: "Workers' compensation jurisdictional fee schedule adjustment.",
    P13:
        "Payment reduced or denied based on workers' compensation jurisdictional regulations or payment policies, use only if no other code is applicable",
    P14:
        'The Benefit for this Service is included in the payment/allowance for another service/procedure that has been performed on the same day.',
    P15: "Workers' Compensation Medical Treatment Guideline Adjustment. To be used for Workers' Compensation only.",
    P16:
        "Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction. To be used for Workers' Compensation only.",
    P17:
        'Referral not authorized by attending physician per regulatory requirement. To be used for Property and Casualty only.',
    P18:
        'Procedure is not listed in the jurisdiction fee schedule. An allowance has been made for a comparable service. To be used for Property and Casualty only.',
    P19:
        'Procedure has a relative value of zero in the jurisdiction fee schedule, therefore no payment is due. To be used for Property and Casualty only.',
    P20:
        'Service not paid under jurisdiction allowed outpatient facility fee schedule. To be used for Property and Casualty only.',
    P21:
        'Payment denied based on the Medical Payments Coverage (MPC) and/or Personal Injury Protection (PIP) Benefits jurisdictional regulations, or payment policies.',
    P22:
        'Payment adjusted based on the Medical Payments Coverage (MPC) and/or Personal Injury Protection (PIP) Benefits jurisdictional regulations, or payment policies.',
    P23:
        'Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional fee schedule adjustment.',
    P24: 'Payment adjusted based on Preferred Provider Organization (PPO).',
    P25: 'Payment adjusted based on Medical Provider Network (MPN).',
    P26: 'Payment adjusted based on Voluntary Provider network (VPN). ',
    P27: 'Payment denied based on the Liability Coverage Benefits jurisdictional regulations and/or payment policies.',
    P28:
        'Payment adjusted based on the Liability Coverage Benefits jurisdictional regulations and/or payment policies.',
    P29: 'Liability Benefits jurisdictional fee schedule adjustment.',
};

export function getAdjustmentCode(key: string) {
    const value = AdjustmentCodes[key as keyof typeof AdjustmentCodes];
    return value ? `[${key}] ${value}` : key;
}
